import { useEffect, useState, useRef } from "react";
import { Navigate } from "react-router-dom";
import Layout from '../../layout/default';
import DataTable from 'react-data-table-component';
import { Link} from 'react-router-dom'
import { Button,Breadcrumb,Row } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import AgentDropdown from '../AgentSelectionLists/AgentDropdown';
import { Form } from 'react-bootstrap';
import { useApiClient } from "../../ApiService/useApiClient";

export const MillageCalculationReport = () => {

    const api = useApiClient();
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        AgentID: '',
        FromDate: new Date().toISOString().split('T')[0],
        ToDate: new Date().toISOString().split('T')[0]
    });
    
    const totalMiles = data.reduce((sum, row) => sum + (row.calculatedDistance || 0), 0);
    const totalCost = data.reduce((sum, row) => sum + (row.total_pay || 0), 0);

    const columns = [
        {
            name: 'Date',
            selector: row => new Date(row.date).toLocaleDateString(),
            sortable: true,
        },
        {
            name: 'Carer',
            selector: row => row.assignedAgentId,
            sortable: true,
        },
        {
            name: 'Addresses',
            selector: row => {
                if (!row.places) return '';
                return (
                    <div>
                        {row.places.split('#')
                            .map(place => place.trim())
                            .filter(place => place.length > 0)
                            .map((place, idx) => (
                                <div key={idx}><b>{idx + 1}.</b> {place}</div>
                            ))
                        }
                    </div>
                );
            },
            sortable: true,
            minWidth: "550px", // You can adjust this value as needed
    // Or use width: "400px" for a fixed width
        },
        {
            name: 'Distance (Miles)',
            selector: row => row.calculatedDistance.toFixed(2) + ' mi',
            sortable: true,
        },
        {
            name: 'Pay Rate (£)',
            selector: row => row.pay_rate.toFixed(2),
            sortable: false,
        },
        {
            name: 'Total Pay (£)',
            selector: row => row.total_pay.toFixed(2),
            sortable: true,
        }
    ];
    

    const fetchData = () => {
        setError(null); // Clear previous errors
        setLoading(true);

        // Validation checks
        if (!params.AgentID) {
            setError(new Error('Please select a staff member.'));
            setLoading(false);
            return;
        }
        if (!params.FromDate || !params.ToDate) {
            setError(new Error('Please select both From and To dates.'));
            setLoading(false);
            return;
        }
        if (new Date(params.FromDate) > new Date(params.ToDate)) {
            setError(new Error('From Date cannot be later than To Date.'));
            setLoading(false);
            return;
        }

       
        api.get("HMCareTask/millagecalculate/", {
                AgentID: params.AgentID,
                FromDate: params.FromDate,
                ToDate: params.ToDate
        })
        .then((response) => {
            setData(response.data);
            setLoading(false);
            //console.log(response.data);
        })
        .catch(error => {
            setError(error);
            setLoading(false);
            if(error.response?.status === 401) {
                return <Navigate to="/auths/auth-login" />
            }
        });
    };

    if(!data) return (
        <Layout title="Client Visits" content="container"><Spinner animation="border" variant="primary" /></Layout>
        );;

    return (

        <>
            <Layout title="Client Visits" content="container"> 
            
            <Breadcrumb className="breadcrumb-arrow">
              <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>      
              <Breadcrumb.Item active>Reports</Breadcrumb.Item>
            </Breadcrumb>

        <div style={{ padding: '20px' }}>
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                marginBottom: '20px'
            }}
            
            >
            <AgentDropdown
                value={params.AgentID}
                onChange={e => setParams(p => ({ ...p, AgentID: e.target.value }))}
            />

            <Form.Control
                type="date"
                value={params.FromDate}
                onChange={e => setParams(p => ({ ...p, FromDate: e.target.value }))}
                style={{ maxWidth: '150px' }}
            />

            <span>TO</span>

            <Form.Control
                type="date"
                value={params.ToDate}
                onChange={e => setParams(p => ({ ...p, ToDate: e.target.value }))}
                style={{ maxWidth: '150px' }}
            />

            <Button
                variant="outline-primary"
                onClick={fetchData}
                style={{ height: '40px', minWidth:'300px' }}
                disabled={loading}
            >
                {loading ? "Running" : "Run Report"}
            </Button>
            </div>

            {/* {error && <div>Error: {error.message}</div>} */}
            {error && (
  <div className="alert alert-danger" role="alert" style={{ marginBottom: '15px' }}>
    {error.message}
  </div>
)}


            
            {data && data.length !== 0 &&
            <>
            <div style={{ fontWeight: 'bold', margin: '10px 0' }}>
                Total Transport Amount : £ {totalCost.toFixed(2)} ( {totalMiles.toFixed(2)} mi)
            </div>
            <DataTable
                //title="Driving Distance Report"
                columns={columns}
                data={data}
                striped = {true}
                pagination
                highlightOnHover
            />       
            </>
            }
        </div>

        </Layout>
        </>
    )
}
